<!-- Breadcrumb -->
<div class="store-breadcrumb">
    <div class="container">
        <a href="/">Home</a>
        <span class="sep">
            <svg class="icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        </span>
        <span class="current">Popular Deals & Offers</span>
    </div>
</div>

<!-- Main Content -->
<main class="main-content">
    <section class="section deals-page-section bg-white">
        <div class="container">

            <!-- Section Header with Green Accent Underline (Ref Design) -->
            <div class="deals-heading-wrap">
                <h1 class="deals-heading-title">Deals of the Day - {{today | date:'dd MMM yyyy'}}</h1>
                <div class="deals-heading-accent"></div>
            </div>

            <!-- Filter Category Tabs (Interactive & Scrollable on Mobile) -->
            <div class="deals-filter-bar">
                <button class="deals-filter-btn active" data-filter="all">All Deals</button>
                <!-- <button class="deals-filter-btn" data-filter="retail">Retail & Shopping</button>
                    <button class="deals-filter-btn" data-filter="tech">Tech & Software</button>
                    <button class="deals-filter-btn" data-filter="beauty">Beauty & Kids</button>
                    <button class="deals-filter-btn" data-filter="travel">Travel & Flights</button>
                    <button class="deals-filter-btn" data-filter="lifestyle">Lifestyle & Fitness</button> -->
            </div>

            <!-- Deals Grid (3 Columns on Desktop, 2 on Tablet, 1 on Mobile) -->
            <div class="deals-grid" id="deals-grid-container">
                <!-- Card -->
                <a class="deals-card cursor-pointer" data-category="all" *ngFor="let deal of topDeals; let i = index"
                    (click)="directToDealCodePage(deal)">
                    <div class="deals-card-body">
                        <div class="deals-card-main">
                            <div class="deal-verified"><img src="images/verified-icon.svg" alt="Verified" width="14"
                                    height="14" class="deal-icon">
                                <span>Verified</span>
                            </div>
                            <h2 class="deals-card-title">{{deal.DealTitle}}</h2>
                            <div class="deals-card-price">
                                <span class="deal-current-price">{{deal.DealFinalPrice}}</span>
                                <span class="deal-old-price">{{deal.DealListPrice}}</span>
                            </div>
                            <div class="deal-uses"><img src="images/users-icon.svg" alt="Uses Today" width="14"
                                    height="14" class="deal-icon"
                                    *ngIf="deal.DealClickCount && deal.DealClickCount > 0">
                                <span>{{ deal.DealClickCount }} {{ deal.DealClickCount === 1 ? 'Use' : 'Uses' }}</span>
                            </div>
                        </div>
                        <div class="deals-card-thumb">
                            <img [src]="deal.DealImageUrl ? deal.DealImageUrl : 'no-image'"
                                alt="{{deal.StoreName}} Offer" width="95" height="95"
                                [attr.loading]="i === 0 ? 'eager' : 'lazy'"
                                [attr.fetchpriority]="i === 0 ? 'high' : 'low'" decoding="async">
                        </div>
                    </div>
                    <div class="deals-card-footer">
                        <div class="offer-brand-wrap">
                            <img src="{{deal.StoreLogo}}" alt="{{deal.StoreName}} Logo" class="offer-brand-img"
                                width="65" height="32" loading="lazy">
                        </div>
                        <span class="deals-card-link" (click)="directToDealCodePage(deal)">
                            <span>Get Offer Now</span>
                            <img src="images/arrow-right-icon.svg" alt="Arrow" width="14" height="14"
                                class="deals-link-icon">
                        </span>
                    </div>
                </a>
            </div>

            <!-- Pagination / Load More -->
            <!-- <div class="deals-load-more-wrap">
                <button class="deals-load-more-btn" id="deals-load-more">
                    <span>Load More Deals</span>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </button>
            </div> -->
        </div>
    </section>

</main>